// ── Web-Push: общие типы протокола (source of truth для сервера и клиента) ──
//
// Push-слой намеренно отделён от внутреннего «колокольчика» (domain.ts
// NotificationType / AppNotification): он покрывает более широкий набор типов и
// категорий и не трогает существующую логику белла. Доменное событие → push-тип
// → категория (для гейтинга настройками) → шаблон → PushPayload.
/** Тип → категория настроек. Новый тип добавляется одной строкой. */
export const PUSH_TYPE_CATEGORY = {
    direct_message: 'direct_messages',
    dm_call_missed: 'calls',
    friend_request: 'friend_requests',
    friend_accepted: 'friend_accepted',
    room_invite: 'room_invites',
    room_started: 'room_started',
    system: 'system',
    news: 'news',
    marketing: 'marketing',
};
/** Полный список категорий с человекочитаемыми подписями (для страницы настроек). */
export const PUSH_CATEGORIES = [
    { id: 'direct_messages', label: 'Личные сообщения', hint: 'Новые сообщения в диалогах' },
    { id: 'calls', label: 'Звонки', hint: 'Пропущенные звонки в личных сообщениях' },
    { id: 'friend_requests', label: 'Заявки в друзья', hint: 'Когда вам отправили заявку' },
    { id: 'friend_accepted', label: 'Принятие заявки', hint: 'Когда вашу заявку приняли' },
    { id: 'room_invites', label: 'Приглашения в комнаты', hint: 'Когда вас зовут смотреть' },
    { id: 'room_started', label: 'Начало просмотра', hint: 'Когда в комнате запустили фильм' },
    { id: 'system', label: 'Системные', hint: 'Обновления и важные объявления' },
    { id: 'news', label: 'Новости', hint: 'Новые функции и события' },
    { id: 'marketing', label: 'Маркетинговые', hint: 'Акции и предложения' },
];
//# sourceMappingURL=push.js.map